import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Chip, Box, CircularProgress, Stack } from '@mui/material';

const getTempoColor = (valor) => {
  if (typeof valor !== 'number') return 'default';
  if (valor <= 30) return 'success'; // verde
  if (valor <= 60) return 'warning'; // amarelo
  return 'error'; // vermelho
};

const TempoSaidaBaseContratosTable = ({ data = [], loading = false }) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 220 }}>
        <CircularProgress size={48} thickness={4} />
      </Box>
    );
  }

  // Ordena do menor para o maior tempo (menor tempo é melhor)
  const sorted = [...data].sort((a, b) => {
    const aVal = typeof a.tempo_medio_saida_base_minutos === 'number' ? a.tempo_medio_saida_base_minutos : 99999;
    const bVal = typeof b.tempo_medio_saida_base_minutos === 'number' ? b.tempo_medio_saida_base_minutos : 99999;
    return aVal - bVal;
  });

  return (
    <TableContainer component={Paper} sx={{ borderRadius: 3, boxShadow: 3, mt: 3 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ px: 2, pt: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          Tempo de Saída da Base
        </Typography>
      </Stack>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 700, textAlign: 'center', width: 80 }}>Ranking</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Contrato</TableCell>
            <TableCell sx={{ fontWeight: 700, textAlign: 'center' }}>Tempo Médio de Saída da Base</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sorted.length === 0 ? (
            <TableRow>
              <TableCell colSpan={3} align="center">
                <Typography color="text.secondary">Nenhum dado encontrado.</Typography>
              </TableCell>
            </TableRow>
          ) : (
            sorted.map((row, idx) => {
              const rank = idx + 1;
              let rankColor = undefined;
              // Menor tempo é melhor, então top 3 (menores tempos) são verdes
              if (idx === 0 || idx === 1 || idx === 2) rankColor = 'success.main';
              else if (idx >= 3 && idx <= 6) rankColor = 'warning.main';
              else if (idx >= 7) rankColor = 'error.main';
              
              const tempo = typeof row.tempo_medio_saida_base_minutos === 'number' 
                ? Math.round(row.tempo_medio_saida_base_minutos) 
                : null;
              
              return (
                <TableRow key={row.des_contrato || idx} hover>
                  <TableCell align="center" sx={{ fontWeight: 700, fontSize: 18, color: rankColor }}>
                    {rank}
                  </TableCell>
                  <TableCell>{row.des_contrato}</TableCell>
                  <TableCell align="center">
                    <Chip
                      label={tempo !== null ? `${tempo} min` : '--'}
                      color={getTempoColor(tempo)}
                      size="small"
                      sx={{ fontWeight: 700, minWidth: 100 }}
                    />
                  </TableCell>
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TempoSaidaBaseContratosTable;

